import { call, put, takeEvery } from "redux-saga/effects"
import { MONITOR_LOAD,EXPORT_ORDERS } from "./actionTypes"
import { monitorError, loadOrders,exportSuccess } from "./actions"
import service from "../../../api/monitor.service"

function* loadMonitorOrders(filter) {
  try {
    const response = yield call(service.getOrder, filter.payload)
    const error = response?.response?.data?.error
    if (error) {
      yield put(monitorError(error))
    } else {
      yield put(loadOrders(response?.data))
    }


  } catch (error) {
    yield put(monitorError(error.message))
  }
}
function* exportExcel(filter) {
  try {
    const response = yield call(service.exportOrder, filter.payload)
    const error = response?.response?.data?.error
    if (error) {
      yield put(monitorError(error))
    } else {
      yield put(exportSuccess(response?.data))
    }
  }catch (error) {
    yield put(monitorError(error.message))
  }
}


function* monitorSaga() {
  yield takeEvery(MONITOR_LOAD, loadMonitorOrders)
  yield takeEvery(EXPORT_ORDERS, exportExcel)
}

export default monitorSaga
